import { OrderModalData } from "../utils/buildQuotaOrderDetailItems";

export type { OrderModalData };

export interface ModalOrderLoaderProps {
  withTab: boolean;
  isOpen: boolean;
  data: OrderModalData;
  isApproved?: boolean;
  isView?: boolean;
  handleClose: (open: boolean, flag: string) => void;
}

export const content = {
  productName: {
    title: "Nome do produto",
  },
  modality: {
    title: "Modalidade",
  },
  quantity: {
    title: "Quantidade",
  },
};
